// extracted by mini-css-extract-plugin
export default {"button":"qUNj6A","text":"ZyQvAR","searchFadeIn":"qDtw4T"};